import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filter, find, propEq } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import * as CareerCard from '@components/LibraryProgramsCareer';
import * as BadgeCard from '@components/LibraryProgramsBadge';
import * as CertificateCard from '@components/LibraryProgramsCertification';
import { AppActions, DevelopActions } from '~/actions';
import withNavigate from '~/hocs/withNavigate';

//@TODO:Check data connections
class ProgramEdit extends Component {
    constructor(props) {
        super(props);
        
        const type = props.match?.params?.activeTab;
        const id = Number(props.match?.params?.id || 0);
        const { templates } = props;
        const program = templates[type]?.data ? find(propEq('id', id), templates[type].data) : null;
        
        this.state = { id, type, program };
    }

    componentDidMount() {
        this.updateStateFromProps(this.props);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { match, templates } = nextProps;
        if (!match?.params) {
            return null;
        }
        const type = match.params.activeTab;
        const id = Number(match.params.id);
        if (id !== prevState.id || !prevState.program) {
            const program = templates[type]?.data ? find(propEq('id', id), templates[type].data) : null;
            return { id, type, program };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        // Check if the route parameters changed
        if (prevProps.match?.params?.activeTab !== this.props.match?.params?.activeTab || 
            prevProps.match?.params?.id !== this.props.match?.params?.id || 
            prevProps.templates !== this.props.templates) {
            this.updateStateFromProps(this.props);
        }
    }

    updateStateFromProps(props) {
        const { match, templates } = props;
        if (match?.params && templates) {
            const type = match.params.activeTab;
            const id = Number(match.params.id);
            const program = find(propEq('id', id), templates[type]?.data || []);
            this.setState({ id, type, program });
        }
    }

    handleSelectMenu = (e) => {
        const { program, type } = this.state;
        const { companyId } = this.props;
        switch (e) {
            case 'assign':
                this.props.toggleModal({
                    type: 'Assign Program',
                    data: { before: { modules: [program] }, after: [], companyId },
                });
                break;
            case 'detail view':
                this.props.navigate({
                    pathname: `/library/programs/${type}/${program.id}/view`,
                    state: { editable: false },
                });
                break;
            case 'edit':
                this.props.navigate({
                    pathname: `/library/programs/${type}/${program.id}/edit`,
                    state: { editable: true },
                });
                break;
            case 'quick assign':
                this.props.toggleModal({
                    type: 'Quick Assign',
                    data: {
                        before: { template: program, type: 'Program', from: 'template', companyId },
                    },
                });
                break;
            default:
                break;
        }
    };

    render() {
        const { role, companyId, authors, departments, competencies, categories, companies, navigate, location } = this.props;
        const { program, type } = this.state;

        const tags = { authors, departments, competencies, categories };
        const quotaOptions = filter((x) => !x.label.includes('Quarter'), this.props.quotaOptions);
        const company = find(propEq('id', companyId), companies);
        const jobRoles = company?.job_roles || [];

        return (
            <ErrorBoundary>
                <Filter back={`all ${type}`} />
                {type === 'careers' && (
                    <CareerCard.Edit
                        tags={tags}
                        jobs={jobRoles}
                        userRole={role}
                        program={program}
                        navigate={navigate}
                        location={location}
                        quotaOptions={quotaOptions}
                        onModal={(e) => this.props.toggleModal(e)}
                        onSave={(e, image) => this.props.saveProgram(e, image)}
                        onSelect={this.handleSelectMenu}
                    />
                )}
                {type === 'certifications' && (
                    <CertificateCard.Edit
                        tags={tags}
                        jobs={jobRoles}
                        userRole={role}
                        program={program}
                        navigate={navigate}
                        location={location}
                        quotaOptions={quotaOptions}
                        onModal={(e) => this.props.toggleModal(e)}
                        onSave={(e, image, pdf) => this.props.saveProgram(e, image, pdf)}
                        onSelect={this.handleSelectMenu}
                    />
                )}
                {type === 'badges' && <BadgeCard.Detail data={program} />}
            </ErrorBoundary>
        );
    }
}

ProgramEdit.propTypes = {
    role: PropTypes.number,
    templates: PropTypes.any,
    authors: PropTypes.array,
    categories: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    saveProgram: PropTypes.func,
    toggleModal: PropTypes.func,
};

ProgramEdit.defaultProps = {
    role: 1,
    companyId: 0,
    templates: {},
    authors: [],
    categories: [],
    departments: [],
    competencies: [],
    companies: [],
    saveProgram: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    role: state.app.app_role_id,
    companyId: state.app.company_info.id,
    templates: state.develop.templates,
    authors: state.app.authors,
    categories: state.app.categories,
    departments: state.app.departments,
    competencies: state.app.competencies,
    companies: state.app.companies,
    quotaOptions: state.develop.libraryQuotaOptions,
});

const mapDispatchToProps = (dispatch) => ({
    getLibraryTemplates: () => dispatch(DevelopActions.getlibrarytemplatesRequest()),
    getProgramDetail: (e) => dispatch(DevelopActions.libraryprogramdetailRequest(e)),
    saveProgram: (e, image, pdf) => dispatch(DevelopActions.librarysaveRequest(e, image, pdf)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const ProgramEditWithNavigate = withNavigate(ProgramEdit);
export default connect(mapStateToProps, mapDispatchToProps)(ProgramEditWithNavigate);
